import { render, staticRenderFns } from "./thirdShopForm.vue?vue&type=template&id=1ca970d4"
import script from "./thirdShopForm.vue?vue&type=script&lang=js"
export * from "./thirdShopForm.vue?vue&type=script&lang=js"
import style0 from "./thirdShopForm.vue?vue&type=style&index=0&id=1ca970d4&prod&lang=css"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports